<div *ngIf="isShowLoader" class="loader2">
    <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="100" height="100">
</div>
<div class="diag_mainDiv" *ngIf="!isShowLoader">
    <form name="identifyFailureForm" method="post">
        <p>{{'Diagnostic Components available for the currently selected vehicle'|translate}}.</p>
        <div class="diag_doNotFloat">
            <table class="diag_mainTable" cellspacing="0" cellpadding="3">
                <tbody>
                    <tr>
                        <td class="diag_prompt diag_align">{{'VIN'|translate}}:</td>
                        <td class="diag_td_text">
                            <input type="text" name="diagvin" maxlength="17" size="30" [(ngModel)]="diagvin" (keyup)="vinNumberChange(diagvin)">
                        </td>
                    </tr>
                    <tr *ngIf="diagerrorflag" style="color: red;">
                        <td></td><td>{{diagerrormsg|translate}}</td>
                    </tr>
                    <tr *ngIf="isRvcGenUser">
                      <td class="diag_prompt diag_align">{{'Dealer Code'|translate}}:</td>
                      <td class="diag_td_text">
                        <input
                          type="text"
                          name="dealerCodeInput"
                          [(ngModel)]="dealerCode"
                          maxlength="20"
                          size="15"
                          placeholder="Enter dealer code">
                      </td>
                    </tr>
                    <tr>
                        <td class="diag_prompt diag_align">{{'Group'|translate}}:</td>
                        <td class="diag_td_text">
                            <select name="diaggroupName" [(ngModel)]="diaggroupName" [disabled]="diagdisabledGroup" #diagsetGroupname
                                (change)="diagonSelectgroup(diagsetGroupname.value,1)" class="diag_s_pos">
                                <option value="default">{{'Select'|translate}}</option>
                                <option *ngFor="let g of diaggroupSearch" [value]="g">{{g}}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td class="diag_prompt diag_align">{{'Section'|translate}}:</td>
                        <td class="diag_td_text">
                            <select *ngIf="!diagsecheck" name="diagsectionName1" [(ngModel)]="diagsectionName" [disabled]="diagdisabledSection"
                                (change)="diagonSelectSection(diagsectionName)" class="diag_s_pos">
                                <option value="default">{{'Select'|translate}}</option>
                                <option *ngFor="let s of diagsectionArray" [value]="s">{{s}}</option>
                                <option *ngIf="diagflagsection" [selected]="diagflagsection" value="diagflagsection">{{'Other not on list'|translate}}</option>
                            </select>
                            <select *ngIf="diagsecheck" name="diagsectionName2" [(ngModel)]="diagsectionName"
                                (change)="diagonSelectSection(diagsectionName)" class="diag_s_pos">
                                <option value="default">{{'Select'|translate}}</option>
                                <option *ngIf="diagflagsection" [selected]="diagflagsection" value="diagflagsection">{{'Other not on list'|translate}}</option>
                            </select>
                            &nbsp;
                            <img *ngIf="!diagchangeSectionList" alt="-" title="Turn off qualifier filter"
                                (click)="diagonSelectgroup(diagsetGroupname.value,2);diagchangeSectionList=!diagchangeSectionList"
                                style="vertical-align: middle;" src="/assets/images/nav.gif" width="18" height="18">
                            <img *ngIf="diagchangeSectionList" alt="+" title="Turn on qualifier filter"
                                (click)="diagonSelectgroup(diagsetGroupname.value,3);diagchangeSectionList=!diagchangeSectionList"
                                style="vertical-align: middle;" src="/assets/images/NavOn.gif" width="18" height="18">
                                <span> - {{'If you cannot see the required section, turn off the qualification filter and try again'|translate}}.</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="diag_prompt diag_align">{{'Component'|translate}}:</td>
                        <td class="diag_td_text">
                            <select *ngIf="!diagcocheck" name="diagcomponentName" [(ngModel)]="diagcomponentName" [disabled]="diagdisabledcomponent" #diagsetCompname
                                (change)="diagonSelectComponent(diagsetCompname.value)" class="diag_s_pos">
                                <option value="default">{{'Select'|translate}}</option>
                                <option *ngFor="let c of diagcomponentSearch" [value]="c">{{c}}</option>
                                <option *ngIf="diagflagsection" [selected]="diagflagsection" value="diagflagsection">{{'Other not on list'|translate}}</option>
                            </select>
                            <select *ngIf="diagcocheck" name="diagcomponentName" [(ngModel)]="diagcomponentName" [disabled]="diagdisabledcomponent" #diagsetCompname
                                (change)="diagonSelectComponent(diagsetCompname.value)" class="diag_s_pos">
                                <option value="default">{{'Select'|translate}}</option>
                                <option *ngIf="diagflagsection" [selected]="diagflagsection" value="diagflagsection">{{'Other not on list'|translate}}</option>
                            </select>
                        </td>
                    </tr>
                    <tr *ngIf="isRvcGenUser">
                      <td></td>
                      <td class="diag_td_text">
                        <button class="btn btn-primary shadow-none"
                                (click)="generateRvc()" [disabled]="isLoading ||!diagvin || !dealerCode ||diagcomponentName === 'default' ||
                                !isComponentDetailsLoaded ||isOtherNotOnListSelected()"
                                style="margin-right: 10px;padding: 8px 20px; font-size: 12px;">
                          <span *ngIf="!isLoading">{{'Generate RVC'|translate}}</span>
                          <span *ngIf="isLoading">{{'Generating'|translate}}</span>
                        </button>
                        <img *ngIf="isFetchingComponentDetails" src="assets/images/ajax-loader.gif" width="20" height="20" alt="Loading..." style="vertical-align: middle; margin-left: 5px;">
                        <ng-container *ngIf="rvcCode && rvcCode !== 'Error generating RVC'">
                          <input
                            type="text"
                            [value]="rvcCode"
                            readonly
                            size="15"
                            style="margin-right: 5px;"><div class="copy-icon-wrapper">
                          <img src="assets/images/copy-icon.png" alt="{{'Copy RVC'|translate}}" (click)="copyRvc()"
                               style="cursor: pointer; vertical-align: middle; width: 24px; height: 24px;"
                               title="{{'Copy RVC'|translate}}">

                          <span *ngIf="showCopiedMessage" class="copied-message-tooltip">
                            {{'Copied'|translate}}
                            </span>
                          </div>
                        </ng-container>
                      </td>
                    </tr>
                </tbody>
            </table>
            <p>{{'Identify Failure text4'|translate}}</p>
        </div>
    </form>
</div>
